import PropTypes from 'prop-types';
import React from 'react';
// reactstrap components
import { Row } from 'reactstrap';

class StudyHeaderChosen extends React.Component {
  handleOnBackButton = () => {
    this.props.history('/app/study');
  };

  render() {
    return (
      <div>
        <div className="study-header-body-changed pl-sm-4">
          <Row
            className="back-to-study mt-5 mt-md-0 pl-2 pl-md-0"
            onClick={this.handleOnBackButton}
          >
            <i className="icon-chevron_left material-back" />
            STUDY HOME
            <i className="icon-chevron_left material-back" />
            {this.props.mainTitle.toUpperCase()}
          </Row>
          <Row className="title-bar mr-0 ml-0">
            <div className="study-header-main-title-and-button-container d-flex flex-row justify-content-between align-items-center flex-wrap w-100">
              <div className="title-text-large-changed">
                {this.props.mainTitle}
              </div>
            </div>
          </Row>
          {/* <Row className="title-bar mr-0 ml-0">
            <div className="study-header-main-title-and-button-container d-flex flex-row justify-content-between align-items-center flex-wrap w-100">
              <div className="title-text-large-changed">
                {this.props.mainTitle}
              </div>
              <Link to="/app/account-settings">
                <button
                  className="btn btn-outline rounded-lg btn-choose-qual"
                  onClick={() =>
                    this.props.setFlashSectionChoose({
                      value: true,
                      typeChoose: 'Qual',
                    })
                  }
                >
                  CHOOSE QUAL FOR DAILY QUIZ
                </button>
              </Link>{' '}
            </div>
          </Row> */}
        </div>
        <div className="gradient-divider" />
      </div>
    );
  }
}

StudyHeaderChosen.propTypes = {
  // objects given by the Main Header
  mainTitle: PropTypes.string,
  History: PropTypes.object,
};

export default StudyHeaderChosen;
